import type { IntegrationProvider } from './types';

const hubspotProvider: IntegrationProvider = {
  key: 'hubspot',
  label: 'HubSpot',
  capabilities: {
    supportsFieldMapping: true,
    supportsRoleMapping: true,
    supportsRelationshipMapping: true,
    supportsWriteback: true,
  },
  flowKeys: {
    firstSync: {
      accounts: 'first-sync-for-accounts',
      contacts: 'first-sync-for-contacts',
      deals: 'first-sync-for-deals',
      notes: 'first-sync-for-notes',
      tasks: 'first-sync-for-tasks',
      emails: 'first-sync-for-emails',
    },
    receive: {
      accounts: 'receive-account-events',
      contacts: 'receive-contact-events',
      deals: 'receive-deal-events',
      notes: 'receive-note-events',
      tasks: 'receive-task-events',
      emails: 'receive-email-events',
    },
    send: {
      accounts: 'send-account-events',
      contacts: 'send-contact-events',
    },
  },
  supportedObjects: ['accounts', 'contacts', 'companies', 'deals', 'notes', 'tasks', 'emails', 'conversation_messages', 'users'],
  activatableObjects: ['accounts', 'contacts', 'deals', 'notes', 'tasks', 'emails'],
  defaultSourceCollections: {
    accounts: 'companies',
    contacts: 'contacts',
    deals: 'deals',
    notes: 'notes',
    tasks: 'tasks',
    emails: 'emails',
  },
  systemMappingFields: [
    { sourceFieldName: 'hubspot_url', destinationFieldName: 'hubspot_url' },
    { sourceFieldName: 'hubspot_record_id', destinationFieldName: 'hubspot_record_id' },
  ],
};

export default hubspotProvider;
